<template>
  <div>
      <div id="myChart">
        <van-loading v-if="isLoading" />
      </div>
  </div>
</template>

<script>
export default {
  name: 'lineEcharts',
  data() {
    return {
      isLoading: true,
      title: '', // 图表标题
      names: ["抽烟","厨师服","鼠患","厨师帽","打电话"], // 显示的名字
      data1: [2,3,5,3,1], // 显示的数据
      res: []
    }
  },

  async created() {
  },
  async mounted() {

  },
  methods: {
    init(name,data){
      this.names = name
      this.data1 = data
      console.log('-----------------data1:',this.data1)
      console.log('-----------------names:',this.names)
      this.drawLine()
    },
    drawLine() {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      const myChart = this.$echarts.init(document.getElementById('myChart'))

      const option = {
        // 设置图标距离四周的距离
        grid: {
          top: 10,
          left: 5, // 调整这个属性
          right: 50,
          bottom: 20
        },
        tooltip: {},
        legend: {
          // data: ['预定次数']
        },
        xAxis: {
          type: 'value',
          axisLine: { show: false }
        },
        yAxis: {
          type: 'category',
          data: this.names,
          axisTick: { show: false },
          axisLine: { show: false },
          // axisLabel: {
          //   show: true,
          //   interval: 0,
          //   rotate: 0,
          //   offsetY: -20, // 向上偏移标签，使其看起来像是位于柱子上方
          //   fontSize: 12
          // }
          axisLabel: { // 控制坐标轴标签
                show: true,
                interval: 0,
                rotate: 0,
                textStyle: {
                    color: '#585858',
                    verticalAlign: 'bottom',
                    fontSize: 13,
                    align: 'left',
                    padding: [0, 0, 15, 12]
                }
            }
        },
        series: [
          {
            type: 'bar',
            data: this.data1,
            barWidth: 12,
            itemStyle: {
              borderRadius: [0, 6, 6, 0],
              color: this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: '#A4E4FF' },
                { offset: 1, color: '#5E8DFA' }
              ])
            }
          }
        ]
      }
      myChart.setOption(option)
      this.isLoading = false
    }
  }
}
</script>
<style lang="less" scoped>
#myChart {
  width: 100%;
  height: 260px;
  padding: 0px;
  background: #fff;
}
</style>
